/* eslint-disable @typescript-eslint/naming-convention */
import { ServiceTokenType } from "#/apis/infra/getServiceTokens";
import { StatisticsResponse } from "#/types/xecguard";

export const initState = {
  axiosLoading: false,
  axiosProgress: {},
  axiosResult: {
    success: false,
    msg: "",
    detail: undefined,
  },
  internalError: null,
  appWidth: 0,
  appHeight: 0,
  headerWidth: 0,
  headerHeight: 0,
  serviceTokens: {
    loading: false,
    results: null as ServiceTokenType[] | null,
  },
  statistics: {
    loading: false,
    cache: {} as Record<string, StatisticsResponse>,
  },
};

export type InfraStateType = {
  axiosLoading: boolean;
  axiosProgress: Record<string, unknown>;
  axiosResult: {
    success: boolean;
    msg: string;
    detail?: Record<string, string>;
  };
  internalError: Record<string, unknown> | null;
  appWidth: number;
  appHeight: number;
  headerWidth: number;
  headerHeight: number;
  serviceTokens: {
    loading: boolean;
    results: ServiceTokenType[] | null;
  };
  statistics: {
    loading: boolean;
    cache: Record<string, StatisticsResponse>;
  };
};
